import styled from 'styled-components';
import { Flex, token, textStyles } from '@bynder/design-system';

export const AlertContent = styled(Flex)`
    background-color: ${token.red500a10};
    padding: ${token.spacing4};
    padding-right: ${token.spacing5};
    border-radius: ${token.radiusBase};
`;

export const AlertIconWrapper = styled.div`
    flex-shrink: 0;
`;

export const AlertBodyWrapper = styled.div`
    ${textStyles.paragraphS};
    white-space: pre-line;
    min-width: 0;
    overflow-wrap: break-word;
`;
